/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PurposeCategory,
    PurposeCategoryFromJSON,
    PurposeCategoryFromJSONTyped,
    PurposeCategoryToJSON,
} from './PurposeCategory';

/**
 * GET /distributors/purpose
 * @export
 * @interface GetPurposeSuccessResponse
 */
export interface GetPurposeSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPurposeSuccessResponse
     */
    status: number;
    /**
     * メッセージ。原則英語。
     * @type {string}
     * @memberof GetPurposeSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PurposeCategory>}
     * @memberof GetPurposeSuccessResponse
     */
    data: Array<PurposeCategory>;
}

export function GetPurposeSuccessResponseFromJSON(json: any): GetPurposeSuccessResponse {
    return GetPurposeSuccessResponseFromJSONTyped(json, false);
}

export function GetPurposeSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPurposeSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PurposeCategoryFromJSON)),
    };
}

export function GetPurposeSuccessResponseToJSON(value?: GetPurposeSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PurposeCategoryToJSON)),
    };
}

